export default __webpack_public_path__ + "static/media/qhacksWordmark-colored.6eee664b.svg";